import { getGenericSpacing } from '@anwb/style-mixins';
/**
 * Panel Helpers
 */
export const getGenericPanelPadding = getGenericSpacing('padding');
export const getGenericPanelMargin = getGenericSpacing('margin');
//# sourceMappingURL=helpers.js.map